import Button from '@material-ui/core/Button';
import { withSnackbar } from 'notistack';
import React, { Component } from 'react';
import { handlePost } from '../../../utils/AxiosUtil';
class WiredObject extends Component {

    handleSubmit = async (event) => {
        console.log(this.props);
        event.persist()
        event.preventDefault();
        const requestObject = {
            "payableId": this.props.row.privateId,
            "type": this.props.row.rowType,
            "wired": this.props.wired
        };
        console.log(requestObject);
        handlePost(this.props.path, requestObject, this);
    };

    handleSuccess = (res) => {
        this.props.refresh();
        this.props.close();
    }

    render() {
        return (
            <form onSubmit={this.handleSubmit}>
                {this.props.comp}
                {this.props.confirm ? <h3>{this.props.confirm}</h3> : <></>}
                <div className="form-actions">
                    <Button className="btn-submit" variant="contained" color="primary" onClick={this.handleSuccess}>
                        Mégse
                    </Button>
                    <Button className="btn-submit" variant="contained" color="primary" type="submit">
                        Igen
                    </Button>
                </div>
            </form>

        )
    }
}

export default withSnackbar(WiredObject);
